<template>
  <ReceiptPage :receipt-type="receiptType"></ReceiptPage>
</template>

<script>
import ReceiptPage from '@/views/modules/erp/pay/index.vue'

export default {
  name: 'ReceiptDetailTable',
  mixins: [],
  components: { ReceiptPage },
  data () {
    return {
      pageType: '',
    }
  },
  activated () {
    this.receiptType = this.$route.params.type
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
